import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from "./baseQuery";

interface IChangePassword {
  oldPassword: string,
  newPassword: string,
}

interface I2FAResponse {
  uri: string;        // QR code data URL or URL
  totpEnabled: boolean;
  backupCodes: string[];
}
interface IConfirm2FARequest {
  code: string;
}
interface IConfirm2FAResponse {
  backupCodes: string[];
}

export const authApi = createApi({
  reducerPath: 'Auth',
  baseQuery: baseQuery({
    baseUrl: '/auth/',
  }),
  tagTypes: ['Auth'],
  endpoints: (build) => ({
    changePassword: build.mutation<IChangePassword, Partial<IChangePassword>>({
      query: (form) => ({
        url: 'change-password',
        method: 'POST',
        body: form,
      }),
    }),
    get2FA: build.query<I2FAResponse, void>({
      query: () => ({
        url: 'init2FA',
        method: 'GET',
      }),
      providesTags: ['Auth'],
    }),
    confirm2FACode: build.mutation<IConfirm2FAResponse, Partial<IConfirm2FARequest>>({
      query: (form) => ({
        url: 'confirm2FACode',
        method: 'POST',
        body: form,
      }),
    }),
    save2FA: build.mutation<void, Partial<void>>({
      query: () => ({
        url: 'save2FA',
        method: 'POST',
      }),
    }),
    remove2FA: build.mutation<void, void>({
      query: () => ({
        url: 'remove2FA',
        method: 'DELETE',
      }),
      invalidatesTags: ['Auth'],
    }),
  }),
});

export const { useChangePasswordMutation, useGet2FAQuery, useConfirm2FACodeMutation, useSave2FAMutation, useRemove2FAMutation } = authApi;
